module.exports = __webpack_public_path__ + "static/agile_vertical-ffc40cefba8fc9cd0908fdeae74465f8.svg";